
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { Textbox } from '@/components/formGroups'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'

export default Vue.extend({
   name: 'ClickAndCollectAddress',
   data: () => ({
      contactPhoneNumber: '',
      highlight: false
   }),
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      physicalAddress(): string {
         return this.modelData.MarketPhysicalAddress
      },
      phoneNumber(): string {
         return this.modelData.MarketPhoneNumber
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   mounted() {
      this.populateDefaultContactPhoneNumber()
   },
   methods: {
      updatePhoneNumber() {
         this.$store.commit('setContactPhoneNumber', this.contactPhoneNumber)
      },
      populateDefaultContactPhoneNumber() {
         const purchase: StoreCheckoutDto = this.$store.state.purchase
         
         if (purchase.ShippingAddress && purchase.ShippingAddress.ContactPhoneNumber) {
            this.contactPhoneNumber = purchase.ShippingAddress.ContactPhoneNumber
            return
         }
         
         if (purchase.BillingAddress && purchase.BillingAddress.ContactPhoneNumber) {
            this.contactPhoneNumber = purchase.BillingAddress.ContactPhoneNumber
            return
         }

         const modelData: CheckoutPageModel = this.$store.state.modelData

         const addresses = modelData.Addresses
         if (!addresses || addresses.length === 0) {
            return
         }
         let defaultAddressId = modelData.DefaultShippingAddressId ?? modelData.DefaultBillingAddressId
         if (!defaultAddressId) {
            const defaultAddressIds = addresses.map(a => a.Id).filter(id => id)
            if (defaultAddressIds.length > 0) {
               defaultAddressId = defaultAddressIds[0]
            }
         }
         if (!defaultAddressId) {
            return
         }
         const defaultAddress = addresses.find(a => a.Id == defaultAddressId)
         if (!defaultAddress) {
            return
         }
         this.contactPhoneNumber = defaultAddress.ContactPhoneNumber
         this.$store.commit('setContactPhoneNumber', this.contactPhoneNumber)
      }
   },
   components: {
      Textbox
   },
})
